import React from 'react';
import { Redirect } from 'react-router-dom';
import { useQuery, Loading, Error } from 'react-admin';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Table from '@material-ui/core/Table';
import DonorStatus from './DonorStatus';
import PhyStatus from './PhyStatus';
import SpeStatus from './SpeStatus';
import { Avatar } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import { makeStyles } from '@material-ui/core/styles';

const useStyles =  makeStyles((theme) => ({
         img: {
            width: '7em',
            minWidth: '1em',
            maxWidth: '8em',
            maxHeight: '8em',
            borderRadius: '50%',
        },
    })
)

/**
 * Donor photo, with a dummy avatar whenever there isn't a usable image.
 *
 * MUI's Avatar falls back in this order: the image, then `children`, then the
 * first letter of `alt`, then its own person icon. With an `alt` and no
 * children, a photo_url that failed to load rendered the letter "D" - so a
 * broken link and a missing link looked like two different things. Passing the
 * icon as children makes every not-a-usable-image case land on the same dummy
 * avatar: no URL, an empty one, a dead link, or a URL that returns something
 * the browser cannot decode as an image.
 *
 * Blank strings are normalised to undefined so the browser is not sent off to
 * fetch the current page and fail to decode it as an image.
 *
 * Defined at module scope, not inside Allergies: makeStyles must not run on
 * every render, and a component re-created each render is a new type to React,
 * which would remount the Avatar and re-trigger the image load.
 */
const GetAvatar = ({ data }) => {
    const classes = useStyles();

    const photo = data && typeof data.photo_url === 'string' && data.photo_url.trim()
        ? data.photo_url
        : undefined;

    return (
        <Avatar
            src={photo}
            alt="Donor Photo"
            className={classes.img}
            sx={{ width: 50, height: 50 }}
        >
            <PersonIcon aria-label="No donor photo on file" />
        </Avatar>
    )
}

const Allergies = ({ssn,...props}) =>{

    let nssn =  (ssn)? ssn: ((props && props.record)? props.record.ssn :  null);


    const { data, loading, error } = useQuery({
        type: 'getOne',
        resource: 'donorbyssn',
        payload:  {id: nssn}
    });

    if (loading) return <Loading />;
    if (error) return <Error />;
    if (!data) return null;

    return (
        <Table  style={{ margin: 'auto',  fontSize:'12px', cellspacing:"3", borderWidth:"1", width:"100%"}} >
        <TableBody  >
        <TableRow style={{ backgroundColor:'#d2dbe2'}}>
                <TableCell><GetAvatar data={data} /></TableCell>
                <TableCell   style={{  textAlign: "left"}}><font color="blue">{(data)? data.name: ''}</font></TableCell>
                <PhyStatus   ssn={nssn}  />
                <SpeStatus   ssn={nssn}  />
                <TableCell   style={{ textAlign: "left" }}>Allergies: {(data && data.allergies) ? <font color="red"><b>{data.allergies}</b></font> :  <font color="green">{'No Allergies'}</font>}</TableCell>
                <DonorStatus ssn={nssn}  />
        </TableRow>
        </TableBody>
        </Table>
        )
}

export default Allergies